import Mustache from 'mustache';
import MustacheComponent from '@components/mustache-component';
import moment from 'moment/moment';

class MatchBarComponent extends MustacheComponent
{
    groupGoals(goals) {
        const indexes = [];
        const grouped = [];

        for (const goal of goals) {
            if (indexes.indexOf(goal.player) < 0) {
                indexes.push(goal.player);
                grouped.push({ player: goal.player, goals: [] });
            }
            const i = indexes.indexOf(goal.player);
            grouped[i].goals.push(goal);
        }
        return grouped;
    }

    prepare(type, data) {
        function getCountdownData(data) {
            const now = moment();
            const time = `${data.matchDate} ${data.startHour}`;
            const matchTime = moment(time, 'DD.MM.YYYY HH:mm');
            const countdown = matchTime.diff(now, 'seconds');

            return {
                status: (matchTime > now) ? 'upcoming' : 'past',
                show: (countdown > 0) && data.showCountdown,
            };
        }

        function getSponsorsData(data) {
            const countdown = getCountdownData(data);
            const sponsors = data.sponsors;

            let css = 'gss-none';
            const show = {
                both: true,
                player: true,
                ipla: true,
                bets: true,
            };
            if ((sponsors.showPlayerAd || sponsors.showIplaAd) && sponsors.showBets) {
                css = 'gss-both';
                if (sponsors.showPlayerAd || sponsors.showIplaAd) {
                    if (sponsors.showPlayerAd) {
                        sponsors.showIplaAd = false;
                    }
                }
            } else {
                if (sponsors.showPlayerAd || sponsors.showIplaAd) {
                    css = 'gss-single gss-player';
                    show.bets = false;
                    if (sponsors.showPlayerAd) {
                        sponsors.showIplaAd = false;
                    }
                } else if (sponsors.showBets) {
                    css = 'gss-single gss-bets';
                    show.player = false;
                } else {
                    show.bets = false;
                    show.player = false;
                    show.both = false;
                }
            }
            return {
                data: sponsors,
                css,
                show,
                countdown: countdown.show,
            };
        }

        switch (type) {
            case 'regular':
            case 'empty': {
                this.data = {
                    data,
                    status: {
                        winner: (data.winner !== void 0) ? String(data.winner).toLowerCase() : 'transparent',
                    },
                };
                break;
            }
            case 'current':
            case 'popover':
            case 'rwd': {
                let status = data.status;
                const countdown = getCountdownData(data);

                if (type === 'popover') {
                    status = countdown.status;
                }
                const sponsored = getSponsorsData(data);

                this.data = {
                    data,
                    status: {
                        name: status,
                        isLive: status === 'live',
                        isPast: status === 'past',
                        isUpcoming: status === 'upcoming',
                    },
                    goals: {
                        home: this.groupGoals(data.homeGoals),
                        away: this.groupGoals(data.awayGoals),
                    },
                    showCountdown: countdown.show,
                    sponsored
                };

                break;
            }
            case 'sponsors': {
                this.data = getSponsorsData(data);
                break;
            }
            default: {
                this.data = {
                    data,
                };
                break;
            }
        }
        return this.data;
    }

    render() {
        const data = this.data;

        const template = this.template;
        const html = Mustache.to_html(template.html(), data);

        return html;
    }
}

export default MatchBarComponent;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/match-bar/match-bar-component.js